import TitleDashboard from "@components/general/Titles/TitleDashboard";
import Loader from "@helpers/loader/loader";
import { Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Animated } from "react-animated-css";
import { Accordion, Card, Col, Container, Form, Image, Navbar, Row } from "react-bootstrap";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import AccordionDatosPersonales from "./accordionItems/AccordionDatosPersonales";
import AccordionDatosDomicilio from "./accordionItems/AccordionDatosDomicilio";
import AccordionDatosCredito from "./accordionItems/AccordionDatosCredito";
import AccordionAutorizacionContrato from "./accordionItems/AccordionAutorizacionContrato";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import UserContext from "@context/User/UserContext";
import { typesOpcionesPagoCompra } from "@helpers/types/typesOpcionesPagoCompra";
import { NotificationManager } from "react-notifications";
import { emailValidator, phoneNumberValidator } from "@helpers/validaciones/validaciones";
import typesMetodosPago from "@helpers/types/typesMetodosPago";
import { actualizarDatosFirma, enviarDomiciliacionSai, generarDomiciliacion, procesarDatosPreRegistro, subirFotosSai, validarDatosPreRegistro } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import { retrievePaymentIntent } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import getPrecioFormateado from "@helpers/formateoPrecios/getPreciosFormateado";
import typesMesesFecha from "@helpers/types/typesMesesFecha";
import getFilledPdfBytes from "@helpers/pdf/getFilledPdfBytes/getFilledPdfBytes";
import getPdfScreenshot from "@helpers/pdf/getPdfScreenshot/getPdfScreenshot";

import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import numberCommaSeparator from "@helpers/formateoPrecios/numberCommaSeparator";
import { enviarComprobanteCompra } from "@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers";
import AccordionDatosDomicilioExterno from "./accordionItems/FormsDomicilioRegiones/AccordionDatosDomicilioExterno";
import { actualizarSuscripcionRegistro, retrieveCheckoutSessionStripe } from "@helpers/httpRequests/httpRequestSuscripciones/httpRequestsSuscripciones";

const particlesOptions = {
	fpsLimit: 60,
	particles: {
		number: {
			value: 100,
			density: {
				enable: true,
			},
		},
		color: {
			value: ["#ffcc00", "#757676", "#ff9900", "#00152A", "#f07f13"],
		},
		opacity: {
			value: { min: 0.1, max: 0.5 },
		},
		size: {
			value: { min: 1, max: 3 },
		},
		move: {
			enable: true,
			speed: 6,
			random: false,
		},
	},
	interactivity: {
		detectsOn: "window",
		events: {
			onClick: {
				enable: true,
				mode: "push",
			},
			resize: true,
		},
	},
	background: {
		// image: "radial-gradient(#4a0000, #000)",
		image: "radial-gradient(#01488f, rgba(0, 21, 42, 1))",
	},
};

const validarCamposVacios = ({ formValues, isCreditoDirecto, setCamposVacios, setEventKey, metodoPago }) => {
	return new Promise(async (resolve, reject) => {
		try {
			for (const formValue in formValues) {
				if (Object.hasOwnProperty.call(formValues, formValue)) {
					const element = formValues[formValue];

					if (element === "") {
						let message = "";

						switch (formValue) {
							// Personales
							case "nombre":
								message = "Ingresa tu nombre completo";
								break;
							case "apellidoPaterno":
								message = "Ingresa tu apellido paterno";
								break;
							case "apellidoMaterno":
								message = "Ingresa tu apellido materno";
								break;
							case "numeroTelefono":
								message = "Ingresa tu número de teléfono a 10 dígitos";
								break;
							case "correo":
								message = "Ingresa tu correo electrónico";
								break;
							case "edad":
								message = "Ingresa tu edad actual";
								break;
							case "estadoCivil":
								message = "Elige tu estado civil actual";
								break;

							// Domicilio
							case "codigoPostal":
							case "ciudad":
							case "estado":
								message = "Ingresa tu código postal";
								break;
							case "calle":
								message = "Ingresa tu calle";
								break;
							case "colonia":
								message = "Ingresa tu colonia";
								break;
							case "numeroExterior":
								message = "Ingresa el número exterior de tu domicilio";
								break;
							case "entreCalles":
								if (isCreditoDirecto) {
									message = "Ingresa entre qué calles se encuentra tu domicilio";
								}
								break;
							case "tiempoResidencia":
								if (isCreditoDirecto) {
									message = "Ingresa cuánto tiempo tienes residiendo en tu domicilio";
								}
								break;

							// Empleo
							case "nombreReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu primera referencia";
								}
								break;
							case "parentescoReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa el parentesco con tu primera referencia";
								}
								break;
							case "numeroTelefonoReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de primera referencia";
								}
								break;
							case "nombreReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu segunda referencia";
								}
								break;
							case "parentescoReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa el parentesco con tu segunda referencia";
								}
								break;
							case "numeroTelefonoReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de segunda referencia";
								}
								break;
							case "nombreEmpresa":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu empresa";
								}
								break;
							case "numeroTelefonoEmpresa":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de tu empresa";
								}
								break;
							case "puesto":
								if (isCreditoDirecto) {
									message = "Ingresa el puesto que ocupas en tu empresa";
								}
								break;
							case "antiguedad":
								if (isCreditoDirecto) {
									message = "Ingresa cuántos años tienes trabajando en tu empresa";
								}
								break;
							case "inicioHorarioLaboral":
								if (isCreditoDirecto) {
									message = "Ingresa la hora de inicio de tu horario laboral";
								}
								break;
							case "finHorarioLaboral":
								if (isCreditoDirecto) {
									message = "Ingresa la hora de fin de tu horario laboral";
								}
								break;

							// Autorizacion
							case "caraFrontalIne":
								if (isCreditoDirecto) {
									message = "Carga la cara frontal de tu INE";
								}
								break;
							case "caraPosteriorIne":
								if (isCreditoDirecto) {
									message = "Carga la cara posterior de tu INE";
								}
								break;
							case "caraFrontalTarjeta":
								if (isCreditoDirecto) {
									message = "Carga la cara frontal de tu tarjeta de débito";
								}
								break;
							case "firma":
								message = "Genera tu firma de contrato";
								break;

							default:
								break;
						}

						if (message !== "") {
							switch (formValue) {
								// Personales
								case "nombre":
								case "apellidoPaterno":
								case "apellidoMaterno":
								case "numeroTelefono":
								case "correo":
								case "edad":
								case "estadoCivil":
									setEventKey("1");
									break;

								// Domicilio
								case "codigoPostal":
								case "calle":
								case "colonia":
								case "ciudad":
								case "estado":
								case "numeroExterior":
								case "entreCalles":
								case "tiempoResidencia":
									setEventKey("2");
									break;

								// Empleo
								case "nombreEmpresa":
								case "numeroTelefonoEmpresa":
								case "puesto":
								case "antiguedad":
								case "inicioHorarioLaboral":
								case "finHorarioLaboral":
								case "nombreReferencia1":
								case "parentescoReferencia1":
								case "numeroTelefonoReferencia1":
								case "nombreReferencia2":
								case "parentescoReferencia2":
								case "numeroTelefonoReferencia2":
									setEventKey("3");
									break;

								// Autorizacion
								case "caraFrontalIne":
								case "caraPosteriorIne":
								case "caraFrontalTarjeta":
								case "firma":
									setEventKey("4");
									break;

								default:
									break;
							}

							return reject(message);
						}
					} else {
						let message = "";

						let eventKey = "";

						switch (formValue) {
							case "numeroTelefono":
							case "numeroTelefonoReferencia1":
							case "numeroTelefonoReferencia2":
							case "numeroTelefonoEmpresa":
								const numeroTelefonoValido = phoneNumberValidator(element);

								if (!numeroTelefonoValido) {
									eventKey = metodoPago !== typesMetodosPago.CREDITO ? "1" : "3";

									switch (formValue) {
										case "numeroTelefono":
											message = "Ingresa tu número de teléfono a 10 dígitos";
											break;

										case "numeroTelefonoReferencia1":
											message = "Ingresa un número de teléfono de 10 dígitos de tu empresa";
											break;

										case "numeroTelefonoReferencia2":
											message = "Ingresa un número de teléfono de 10 dígitos de primera referencia";
											break;

										case "numeroTelefonoEmpresa":
											message = "Ingresa un número de teléfono de 10 dígitos de segunda referencia";
											break;

										default:
											break;
									}
								}

								break;

							case "correo":
								const correoValido = emailValidator(element);

								if (!correoValido) {
									eventKey = "1";

									message = "Ingresa un correo válido";
								}
								break;

							case "edad":
								if (element.length < 2) {
									eventKey = "1";

									message = "Ingresa tu edad correcta";
								}
								break;

							case "codigoPostal":
								if (element.length < 5) {
									eventKey = "2";

									message = "Ingresa un código postal válido";
								}
								break;

							case "inicioHorarioLaboral":
							case "finHorarioLaboral":
								if (element === "-- Selecciona un horario --") {
									eventKey = "3";

									message = `Ingresa un horario de ${formValue.includes("inicio") ? "entrada" : "salida"} de tu empleo`;
								}
								break;

							default:
								break;
						}

						if (message !== "") {
							setEventKey(eventKey);

							return reject(message);
						}
					}
				}
			}

			setCamposVacios(false);

			resolve(true);
		} catch (error) {
			reject(error);
		}
	});
};

const getArrayJsonCargaImagenes = ({idRegion, folioContrato, imagesData }) => {
	return new Promise(async (resolve, reject) => {
		try {
			let arrayJSONFotos = [
				{
					idRegion,
					folioContrato,
					nombreFoto: "03_ife_frente",
					fotoBase64: imagesData.caraFrontalIne,
				},
				{
					idRegion,
					folioContrato,
					nombreFoto: "04_ife_atras",
					fotoBase64: imagesData.caraPosteriorIne,
				},
				{
					idRegion,
					folioContrato,
					nombreFoto: "06_tc",
					fotoBase64: imagesData.caraFrontalTarjeta,
				},
			];

			resolve(arrayJSONFotos);
		} catch (error) {
			console.log(error);

			reject(error);
		}
	});
};

const getFechaString = (date) => {
	let months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

	let year = date.getFullYear();

	let month = months[date.getMonth()];

	let day = date.getDate();

	let formattedDate = day + " de " + month + " del " + year;

	return formattedDate;
};

const getTemplateReplacements = ({ formValues, precios }) => {
	return new Promise(async (resolve, reject) => {
		try {
			const fechaDomiciliacion = new Date();

			const QUINCENAS_POR_MES = 2;

			const COSTO_TOTAL = precios.credito.precioTotal;

			const PAGO_QUINCENAL = precios.credito.pagoQuincenal;

			const QUINCENAS_TOTALES = COSTO_TOTAL / PAGO_QUINCENAL;
			
			const cantidadMeses = QUINCENAS_TOTALES / QUINCENAS_POR_MES;

			const fechaVencimiento = new Date();

			fechaVencimiento.setMonth(fechaDomiciliacion.getMonth() + cantidadMeses);

			resolve({
				tipoLicencia: "Licencia Click+ Premium",
				nombreBanco: formValues.bancoEmisor,
				numeroTarjeta: formValues.numeroTarjetaDomiciliacion,
				montoMaximo: await getPrecioFormateado(precios.credito.precioTotal),
				montoFijo: await getPrecioFormateado(precios.credito.pagoQuincenal),
				nombreTitular: formValues.titularTarjetaDomiciliacion,
				firmaTitular: formValues.firma,
				diasPago: "Días 1 y 15",
				fechaVencimiento: getFechaString(fechaVencimiento),
			});
		} catch (error) {
			console.log(error);

			reject(error);
		}
	});
};

const getFechaDomiciliacion = () => {
	let nombreMes = '';
	let mes = new Date().getMonth() + 1;

	switch (mes) {
		case typesMesesFecha.enero.digito:
			nombreMes = typesMesesFecha.enero.letra;
			break;

		case typesMesesFecha.febrero.digito:
			nombreMes = typesMesesFecha.febrero.letra;
			break;

		case typesMesesFecha.marzo.digito:
			nombreMes = typesMesesFecha.marzo.letra;
			break;

		case typesMesesFecha.abril.digito:
			nombreMes = typesMesesFecha.abril.letra;
			break;

		case typesMesesFecha.mayo.digito:
			nombreMes = typesMesesFecha.mayo.letra;
			break;

		case typesMesesFecha.junio.digito:
			nombreMes = typesMesesFecha.junio.letra;
			break;

		case typesMesesFecha.julio.digito:
			nombreMes = typesMesesFecha.julio.letra;
			break;

		case typesMesesFecha.agosto.digito:
			nombreMes = typesMesesFecha.agosto.letra;
			break;

		case typesMesesFecha.septiembre.digito:
			nombreMes = typesMesesFecha.septiembre.letra;
			break;

		case typesMesesFecha.octubre.digito:
			nombreMes = typesMesesFecha.octubre.letra;
			break;

		case typesMesesFecha.noviembre.digito:
			nombreMes = typesMesesFecha.noviembre.letra;
			break;

		case typesMesesFecha.diciembre.digito:
			nombreMes = typesMesesFecha.diciembre.letra;
			break;

		default:
			break;
	}

    return {
        dia: new Date().getDate().toString(),
        mes: nombreMes,
        anio: new Date().getFullYear().toString().substring(2, 4)
    }
};

const generarDocumentoDomiciliacion = ({ folioContrato, replacements, idRegion }) => {
	return new Promise(async (resolve, reject) => {
        try {
			const data = await fetch(`${ window.location.origin }/assets/templates/domiciliacion/pdf_domiciliacion.pdf`);
			
			const pdfTemplateBytes = await data.arrayBuffer();

			const fechaDomiciliacion = getFechaDomiciliacion();

			const filledPdfBytes = await getFilledPdfBytes({ pdfTemplateBytes, replacements, fechaDomiciliacion });
			
			const formData = new FormData();
			
			formData.append('filledPdf', new Blob([ filledPdfBytes.buffer ]));
			
			const pathPDF = await generarDomiciliacion(formData, folioContrato);

			const pdfScreenshotBytes = await getPdfScreenshot({ filledPdfBytes });
			
			await enviarDomiciliacionSai({
				pathPDF,
				pdfImageBase64: pdfScreenshotBytes
			}, folioContrato, idRegion);

			resolve(true);
        } catch (error) {
            console.log("error al generar el documento de domiciliación: ", error);

            reject(error);
        }
    });
};

const enviarComprobante = (datosComprobante, formValues, datosCompra, paymentMethod, paymentIntent, compraLectura, esCompraExterna) => {
	return new Promise(async (resolve, reject) => {
		try {
			
			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
			
			const { metodoPago, preciosSeleccionados: precios  } = datosCompra;
			
			const { card: { last4 } } = paymentMethod;
			
			const { id: paymentIntentId, amount: montoCobro, payment_method_options: { card } } = paymentIntent;
			
			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

			let pagoMetodo = "";

			switch (metodoPago) {
				case "contado":
					if(card.installments.plan !== null){
						pagoMetodo = `${card.installments.plan.count} Meses sin intereses`;
					}else{
						pagoMetodo = "De contado";
					}
					break;

				case "credito":
					pagoMetodo = "Crédito Directo"
				break;

				case "msi":
					pagoMetodo = `${card.installments.plan.count} Meses sin intereses`
				break;
			
				default:
					break;
			}

			let replacements = {};
			// if(compraLectura){
				replacements = {
				folioContrato,
				titular,
				numeroTarjeta: `Tarjeta con terminación ${ last4 }`,
				// metodoPago: metodoPago === "contado" ? "De contado" : metodoPago === "credito" ? "Crédito Directo" : `${card.installments.plan.count} Meses sin intereses`,
				metodoPago: pagoMetodo,
				description: compraLectura ? `Compra de curso de Lectura Inteligente - Folio ${folioContrato}` :  `Compra de Licencia Click+ Premium - Folio ${folioContrato}`,
				paymentIntentId,
				correo,
				montoCobro: numberCommaSeparator(montoCobro / 100),
				costoBase: compraLectura ? numberCommaSeparator(datosComprobante.montoCobro) : metodoPago === "contado" ? numberCommaSeparator(precios.contado) : metodoPago === "credito" ? numberCommaSeparator(precios.credito.precioTotal) : numberCommaSeparator(precios.msi.monto),
				...(metodoPago === "credito"
					? {
							cantidadRestante: numberCommaSeparator(precios.credito.precioTotal - (montoCobro / 100)),
						}
					: metodoPago.includes("msi")
					? {
							msi: card.installments.plan.count
						}
					: {}),
				currency: esCompraExterna? "USD" : "MXN"
			};
			
			// // }
	
			await enviarComprobanteCompra(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};

const enviarComprobanteKueski = (datosComprobante, formValues, kueskiSession, kueskiAmount, compraLectura) => {
	return new Promise(async (resolve, reject) => {
		try {
			
			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
						
			
			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

	
			let replacements = {};
			// if(compraLectura){
				 replacements = {
					folioContrato,
					titular,
					numeroTarjeta: `Tarjeta usada desde Kueski Pay`,
					metodoPago: "Compra con Kueski Pay",
					description: compraLectura ? `Compra de curso de Lectura Inteligente - Folio ${folioContrato}` :  `Compra de Licencia Click+ Premium - Folio ${folioContrato}`,
					paymentIntentId: kueskiSession.payment_intent,
					correo,
					montoCobro: numberCommaSeparator(kueskiAmount / 100),
					costoBase:  numberCommaSeparator(datosComprobante.montoCobro),
				};
			
			// }
	
			await enviarComprobanteCompra(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};

const enviarComprobanteSuscripcion = (formValues, datosCompra, subscriptionInfo ,compraLectura, esCompraExterna) => {
	return new Promise(async (resolve, reject) => {
		try {
			
			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
			
			const { metodoPago, preciosSeleccionados: precios  } = datosCompra;

			const {last4} = subscriptionInfo.payment[0].card;
									
			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

			let pagoMetodo = "De contado";

			let replacements = {};
			// if(compraLectura){
				replacements = {
				folioContrato,
				titular,
				numeroTarjeta: `Tarjeta con terminación ${ last4 }`,
				// metodoPago: metodoPago === "contado" ? "De contado" : metodoPago === "credito" ? "Crédito Directo" : `${card.installments.plan.count} Meses sin intereses`,
				metodoPago: pagoMetodo,
				description: `Suscripción mensual a Licencia Click+ Ofimática - Folio ${folioContrato}`,
				paymentIntentId: subscriptionInfo.session.invoice,
				correo,
				montoCobro: numberCommaSeparator(subscriptionInfo.session.amount_total / 100),
				costoBase: numberCommaSeparator(subscriptionInfo.session.amount_total / 100),
				currency: esCompraExterna? "USD" : "MXN"
			};
			
			// // }
	
			await enviarComprobanteCompra(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};


const FormularioRegistroSAI = ({ history }) => {
	const [eventKey, setEventKey] = useState("4");

	const buttonRef = useRef();

	const { folioContrato } = useParams();

	const { contextValue, setContextValue } = useContext(UserContext);

	const {
		compra: {compraLectura, compraKueski=false, kueskiAmount = 0, stripeSession, kueskiSession = {}, codigoAplicado, idCodigoDescuento, preciosSeleccionados: precios }
	} = contextValue;

	
	const [showLoader, setShowLoader] = useState(true);

	const [loading, setLoading] = useState(false);

	const [isCreditoDirecto, setIsCreditoDirecto] = useState(false);

	const [paymentIntent, setPaymentIntent] = useState({});

	const [paymentMethod, setPaymentMethod] = useState({});

	const [camposVacios, setCamposVacios] = useState(true);

	const [compraExterna, setCompraExterna] = useState(false);

	const [compraPorSuscripcion, setCompraPorSuscripcion] = useState(false);

	const [checkSessionStripe, setCheckSessionStripe] = useState(undefined);

	const [subscriptionInfo, setSubscriptionInfo] = useState({
		session: {},
		payment: {},
	})

	const [formValues, setFormValues] = useState({
		folioContrato,
		nombre: "",
		apellidoPaterno: "",
		apellidoMaterno: "",
		numeroTelefono: "",
		correo: "",
		edad: "",
		estadoCivil: "",
		codigoPostal: "",
		calle: "",
		colonia: "",
		ciudad: "",
		estado: "",
		numeroExterior: "",
		numeroInterior: "",
		entreCalles: "",
		tiempoResidencia: "",
		nombreEmpresa: "",
		numeroTelefonoEmpresa: "",
		puesto: "",
		antiguedad: "",
		inicioHorarioLaboral: "",
		finHorarioLaboral: "",
		nombreReferencia1: "",
		parentescoReferencia1: "",
		numeroTelefonoReferencia1: "",
		nombreReferencia2: "",
		parentescoReferencia2: "",
		numeroTelefonoReferencia2: "",
		caraFrontalIne: "",
		caraPosteriorIne: "",
		caraFrontalTarjeta: "",
		firma: "",
		numeroTarjetaDomiciliacion: '',
		titularTarjetaDomiciliacion: '',
		bancoEmisor: "",
		region: 1,
	});

	const particlesInit = useCallback(async (engine) => {
		await loadFull(engine);
	}, []);

	//LAS FUNCIONES crearPreRegistroStripe y Kueski nos ayudan a crear el json para procesar el resgistro en SAI correctamente ya que algunos campos varían.

	const crearPreRegistroStripe = (esCompraExterna) => {

		//Realizar la validacion de si es preRegistro standard o por suscripcion stripe.

		//TODO: Sustituir el folio del pago por el id de la suscripcion y el monto ese recuperarlo del obeto del checkout
		const { id: folioPago, amount } = paymentIntent;

		console.log(subscriptionInfo.payment);

		const { card: { last4, funding } } = compraPorSuscripcion ? subscriptionInfo.payment[0] : paymentMethod;

		return {
			folioContrato,
			region: formValues.region,
			metodoPago: compraPorSuscripcion ? 'contado' : stripeSession.metadata.metodoPago,
			tipoPago: "compra",
			montoCobro: compraPorSuscripcion ? subscriptionInfo.session.amount_total / 100 : amount / 100,
			esCompraExterna,
			tipoTarjeta: funding,
			codigoAplicado: compraPorSuscripcion ? true : codigoAplicado,
			idCodigoDescuento: compraPorSuscripcion ? subscriptionInfo.session.subscription.items.data[0].plan.interval === 'year' ? 8 : 7 : idCodigoDescuento,
			folioPago: compraPorSuscripcion ? subscriptionInfo.session.invoice : folioPago,
			estado: formValues.estado,
			municipio: formValues.ciudad,
			datosCliente: {
				nombre: formValues.nombre,
				apellidoPaterno: formValues.apellidoPaterno,
				apellidoMaterno: formValues.apellidoMaterno,
				calle: formValues.calle,
				colonia: formValues.colonia,
				numeroExterior: formValues.region !== 1 ? '07206' : formValues.numeroExterior,
				numeroInterior: formValues.numeroInterior,
				codigoPostal: formValues.region !== 1 ? '07206' : formValues.codigoPostal,
				email: formValues.correo,
				numeroTelefono: formValues.numeroTelefono,
			},
		};
	}

	const crearPreRegistroKueski = (esCompraExterna) => {
		
		return {
			folioContrato,
			region: formValues.region,
			metodoPago: kueskiSession.metadata.metodoPago,
			tipoPago: "compra",
			montoCobro: kueskiAmount / 100,
			esCompraExterna,
			tipoTarjeta: "credit",
			codigoAplicado,
			idCodigoDescuento,
			folioPago: kueskiSession.payment_intent,
			estado: formValues.estado,
			municipio: formValues.ciudad,
			datosCliente: {
				nombre: formValues.nombre,
				apellidoPaterno: formValues.apellidoPaterno,
				apellidoMaterno: formValues.apellidoMaterno,
				calle: formValues.calle,
				colonia: formValues.colonia,
				numeroExterior: formValues.numeroExterior,
				numeroInterior: formValues.numeroInterior,
				codigoPostal: formValues.codigoPostal,
				email: formValues.correo,
				numeroTelefono: formValues.numeroTelefono,
			},
		};
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		//Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		let esCompraExterna = param.get("compraExterna");

		if(esCompraExterna === 'true'){
			console.log("Es compra externa")
			esCompraExterna = true;
		}else{
			esCompraExterna = false;
		}
		//Transformamos el string del data en arreglo

		//Si la variable datosURL es diferente de null es una compra fuera de México

		try {
			setLoading(true);

			if (camposVacios) {
				await validarCamposVacios({
					formValues,
					isCreditoDirecto,
					setCamposVacios,
					setEventKey,
					metodoPago: compraKueski ? kueskiSession.metadata.metodoPago : compraPorSuscripcion ? "contado": stripeSession.metadata.metodoPago,
				});
			}
		} catch (error) {
			console.log("algo sucedió al completar el pre-registro: ", error);

			setEventKey("");

			setLoading(false);

			return NotificationManager.error(error);
		}


		try {
			
			
			const dataPreRegistro = compraKueski === true ? crearPreRegistroKueski(esCompraExterna) : crearPreRegistroStripe(esCompraExterna);
			
			const { idsLocalidad, jsonPreRegistro } = await validarDatosPreRegistro(dataPreRegistro);


			await procesarDatosPreRegistro(jsonPreRegistro);
			
			await actualizarDatosFirma({
				idRegion: formValues.region,
				folioContrato,
				firmaBase64: formValues.firma,
				clienteFirma: {
					edad: formValues.edad,
					estadoCivil: formValues.estadoCivil,
					calle: formValues.calle,
					referencia: formValues.entreCalles,
					colonia: formValues.colonia,
					codigoPostal: formValues.codigoPostal,
					idEstadoCliente: idsLocalidad.idEstado,
					idMunicipioCliente: idsLocalidad.idMunicipio,
					tiempoDomicilio: formValues.tiempoResidencia,
					nombreReferencia1: formValues.nombreReferencia1,
					parentescoReferencia1: formValues.parentescoReferencia1,
					telefonoReferencia1: formValues.numeroTelefonoReferencia1 !== '' ? formValues.numeroTelefonoReferencia1 : '(477) 000-00-00',
					nombreReferencia2: formValues.nombreReferencia2,
					parentescoReferencia2: formValues.parentescoReferencia2,
					telefonoReferencia2: formValues.numeroTelefonoReferencia2 !== '' ? formValues.numeroTelefonoReferencia2 : '(477) 000-00-01',
					horariosLaborales: compraKueski ? '' : compraPorSuscripcion? '' : stripeSession.metadata.metodoPago !== 'credito' ? '' : `De ${formValues.inicioHorarioLaboral} a ${formValues.finHorarioLaboral}`,
				},
			});

			if(!compraKueski && !compraPorSuscripcion) {
				if (stripeSession.metadata.metodoPago === typesMetodosPago.CREDITO) {
					const arrayJSONFotos = await getArrayJsonCargaImagenes({
						idRegion: formValues.region,
						folioContrato,
						imagesData: {
							caraFrontalIne: formValues.caraFrontalIne,
							caraPosteriorIne: formValues.caraPosteriorIne,
							caraFrontalTarjeta: formValues.caraFrontalTarjeta,
						},
					});
	
					await subirFotosSai(arrayJSONFotos);
	
					const domiciliacionReplacementes = await getTemplateReplacements({
						formValues,
						precios
					});
					
					await generarDocumentoDomiciliacion({ folioContrato, replacements: domiciliacionReplacementes, idRegion: formValues.region });
				}
			}

			//TODO Actualizar los datos de la suscripcion para ingresar el folio correspondiente al id de la suscripcion.
				

			if(!compraKueski) {
				if(compraPorSuscripcion){
					await actualizarSuscripcionRegistro({
						idSuscripcionStripe: subscriptionInfo.session.subscription.id,
						idClienteStripe: subscriptionInfo.session.customer.id,
						folioContrato

					})
					await enviarComprobanteSuscripcion(formValues, 149, subscriptionInfo, compraLectura, formValues.region !== 1 ? true : false);
				}else{ 
					await enviarComprobante({
					titular: `${formValues.nombre} ${formValues.apellidoPaterno} ${ formValues.apellidoMaterno }`,
					paymentIntentId: compraKueski ? paymentIntent.id : kueskiSession.payment_intent,
					folioContrato,
					montoCobro: compraKueski ? kueskiAmount / 100 : paymentIntent.amount / 100,
					numeroTarjeta: `Tarjeta con terminación ${compraKueski ? 'XXXX' : paymentMethod.card.last4}`,
					description: `Compra de Licencia Click+ - Folio ${folioContrato}`,
					correo: formValues.correo
				}, formValues, contextValue.compra, paymentMethod, paymentIntent, compraLectura, formValues.region !== 1 ? true : false);
				}
			}else{
				await enviarComprobanteKueski({
					titular: `${formValues.nombre} ${formValues.apellidoPaterno} ${ formValues.apellidoMaterno }`,
					paymentIntentId: compraKueski ? paymentIntent.id : kueskiSession.payment_intent,
					folioContrato,
					montoCobro: compraKueski ? kueskiAmount / 100 : paymentIntent.amount / 100,
					numeroTarjeta: `Tarjeta con terminación ${compraKueski ? 'XXXX' : paymentMethod.card.last4}`,
					description: `Compra de Licencia Click+ - Folio ${folioContrato}`,
					correo: formValues.correo
				}, formValues, kueskiSession, kueskiAmount, compraLectura);
			}

			setContextValue({
				...contextValue,
				compra: {
					...contextValue.compra,
					correo: formValues.correo
				}
			});

			history.replace(dashboardRoutesPaths.pagos.compra.compraFinalizada + `?region=${formValues.region}`);
		} catch (error) {
			console.log("Error al validar los datos para el pre-registro: ", error);

			if (typeof error.data === 'string' && error.data.includes('El folio del contrato ya existe')) {
				NotificationManager.error(error.data);
			}

			if (error.message) {
				NotificationManager.error(error.message);
			}

			setLoading(false);
		}
	};

	const consultarPaymentData = async () => {
		try {
			const { paymentIntent, paymentMethod } = await retrievePaymentIntent(stripeSession.payment_intent);
			setPaymentIntent(paymentIntent);

			setPaymentMethod(paymentMethod);
			
			setShowLoader(!showLoader);
		} catch (error) {}
	};

	const retrieveSubscriptionData = async() => {
		
		try {

			const param = new URLSearchParams(window.location.search);
			let subscriptionStripeSession = param.get("subscription")

			//Enviar al backend el checkout session para recuperar la info.

			const checkSessionInfo = await retrieveCheckoutSessionStripe({checkSessionId: subscriptionStripeSession}); 

			console.log(checkSessionInfo);
			setSubscriptionInfo({
				...subscriptionInfo,
				payment: checkSessionInfo.payment,
				session: checkSessionInfo.session,
			})
			
		} catch (error) {
			console.log('Error al recuperar el checkout session de la suscripcion');
		}

	}

	useEffect(() => {
		// generarDocumentoDomiciliacion({
		// 	folioContrato: "666",
		// 	replacements: {
		// 		tipoLicencia: "Licencia Click+ Premium",
		// 		nombreBanco: "BanBajío",
		// 		numeroTarjeta: "4242 4242 4242 4242",
		// 		montoMaximo: "19,990.00",
		// 		montoFijo: "600.00",
		// 		nombreTitular: "Sergio Antonio Hernandez Ramirez",
		// 		firmaTitular:,
		// 		diasPago: "Días 1 y 15",
		// 		fechaVencimiento: "11 de Mayo del 2025"
		// 	}
		// });

		//Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		let esCompraExterna = param.get("compraExterna");

		//Parametro usado en las compras de las suscripciones desde stripe
		let subscriptionStripeSession = param.get("subscription")

		if(esCompraExterna === 'true'){
			setCompraExterna(true);
		}else{
			setCompraExterna(false);
		}

		if(subscriptionStripeSession){
			setCompraPorSuscripcion(true);
			console.log(subscriptionStripeSession);
			setCheckSessionStripe(subscriptionStripeSession);
			//Funcion para recuperar la info del cliente y su suscripcion usando el checkout session.
			retrieveSubscriptionData();
		}

		if (stripeSession) {
			if (stripeSession.metadata.metodoPago === typesOpcionesPagoCompra.credito) {
				setIsCreditoDirecto(true);
			}

			consultarPaymentData();
		}else{
			setShowLoader(!showLoader);
		}

		// setTimeout(() => setShowLoader(!showLoader), 1500);
	}, []);

	useEffect(() => {
		if (eventKey !== "" && eventKey !== "4") {
			buttonRef.current?.click();
		}
	}, [eventKey]);

	useEffect(() => {
		if(compraExterna) {
			setFormValues({
				...formValues,
				codigoPostal: '07206',
				numeroExterior: '0000'
			})
		}
	}, [formValues]);

	return showLoader ? (
		<Loader />
	) : (
		<>
			<Particles options={particlesOptions} init={particlesInit} id="tsparticles" />

			<Animated animationIn="fadeIn" isVisible={true}>
				<div id="particles" className="container-form-registro">
					<Navbar style={{ backgroundColor: "transparent!important" }}>
						<Container fluid>
							<Row>
								<Col>
									<Navbar.Brand href="#home">
										<Image src={require("@assets/images/logo-gc-horizontal.png")} width={150} />
									</Navbar.Brand>
								</Col>
							</Row>
						</Container>
					</Navbar>

					<Container fluid="md" className="pb-4">
						<Row>
							<Col>
								<Card body className="card-form-registro">
									<Container fluid id="container-card" className="">
										<Row className="d-flex align-items-stretch">
											<Col xs={12} lg={5} xl={4} className="px-0 px-lg-auto">
												<div className="img-bg-form-registro sai"></div>
											</Col>

											<Col xs={12} lg={7} xl={8} className="px-0">
												<Form className="form-registro-sai p-md-2" onSubmit={handleSubmit}>
													<Container fluid className="text-white">
														<TitleDashboard title="Comienza tu Registro" />

														<Typography variant="overline">Llena el siguiente formulario para comenzar con tu registro en Click+</Typography>

														<Accordion className="ms-lg-3 my-3 form-accordion" defaultActiveKey="1" flush data-bs-theme="dark">
															<AccordionDatosPersonales formValues={formValues} setFormValues={setFormValues} />

															{compraExterna ? (
																<AccordionDatosDomicilioExterno compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} />
															): (
																<AccordionDatosDomicilio compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} />
															)}

															{/* <AccordionDatosDomicilio compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} /> */}

															{isCreditoDirecto ? <AccordionDatosCredito formValues={formValues} setFormValues={setFormValues} /> : null}

															<AccordionAutorizacionContrato
																loading={loading}
																formValues={formValues}
																setFormValues={setFormValues}
																isCreditoDirecto={isCreditoDirecto}
																buttonRef={buttonRef}
																eventKey={eventKey}
															/>
														</Accordion>
													</Container>
												</Form>
											</Col>
										</Row>
									</Container>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</Animated>
		</>
	);
};

export default FormularioRegistroSAI;
